import SearchUrlAdapter from './SearchUrl';
import ArticleAdapter from './Article';

export default class {
  constructor({ searchUrl, article }) {
    this.searchUrl = new SearchUrlAdapter(searchUrl);
    this.article = new ArticleAdapter(article);
  }

  get adUnitAttributes() {
    return {
      ...this.searchUrl.adUnitAttributes,
      ...this.article.adUnitAttributes,
    };
  }

  get targeting() {
    return {
      ...this.searchUrl.targeting,
      ...this.article.targeting,
    };
  }
}
